module.exports = __webpack_public_path__ + "img/icon-round-dollar.3c10c554.svg";